import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=logged in
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    const boot = async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      } finally {
        setInitializing(false);
      }
    };
    boot();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data?.requires_2fa) {
      // Bubble up to UI without setting user
      return { requires_2fa: true, challenge_token: data.challenge_token, email: data.email };
    }
    if (data?.token) localStorage.setItem("ss_token", data.token);
    setUser(data);
    return data;
  };

  const verify2FA = async ({ challenge_token, totp_code, backup_code }) => {
    const { data } = await api.post("/auth/2fa-verify", { challenge_token, totp_code, backup_code });
    if (data?.token) localStorage.setItem("ss_token", data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("ss_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, verify2FA, logout, initializing }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
